import React, { useEffect, useState } from "react";
import { Input, InputLabel } from "@mui/material";
import "./Updatecommunity.css";
import { State, City } from "country-state-city";
import {
  updateCommunityApi,
  fetchCommunityDocName,
  fetchCommunityByCommunityId,
} from "../../Services/Community/CommunityAPI/communityApi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { CommunityOwner, SuperAdmin } from "../../Utils/Constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function UpdatecommunityComp() {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [errors, setErrors] = useState({});

  const location = useLocation();
  const idFromState = location.state?.communityId; // Access the state passed

  useEffect(() => {
    dispatch(fetchCommunityDocName());
  }, [dispatch]);

  // State for form inputs
  const [formData, setFormData] = useState({
    community_name: "",
    city: "",
    state: "",
    type: "",
    unit: "",
    doc_type: "",
    doc_type_name_id: "",
    owned_by: "",
    community_documents: null,
  });
  const userId = localStorage.getItem("user_id");
  const user_type = localStorage.getItem("user_type");

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (idFromState) {
          const response = await dispatch(
            fetchCommunityByCommunityId(idFromState)
          ).unwrap();

          setFormData({
            community_name: response?.data?.community_name || "",
            city: response?.data?.location?.city || "",
            state: response?.data?.location?.state || "",
            type: response?.data?.type || "",
            unit: response?.data?.unit || "",
            owned_by: response?.data?.owned_by,
          });

          const stateCities = City.getCitiesOfState(
            "US",
            response?.data?.location?.state
          );
          setCities(stateCities);
        }
      } catch (error) {
        console.error("Error fetching community data:", error);
      }
    };

    fetchData();
  }, [idFromState, dispatch]);

  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      state: selectedState,
      city: "",
    }));

    const stateCities = City.getCitiesOfState("US", selectedState);
    setCities(stateCities);
  };

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      city: selectedCity,
    }));
  };

  const handleTypeChange = (e) => {
    const selectedType = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      type: selectedType,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // const validateForm = () => {
  //   const errors = {};
  //   if (!formData.community_name)
  //     errors.community_name = "Community Name is required";
  //   if (!formData.state) errors.state = "State is required";
  //   if (!formData.city) errors.city = "City is required";
  //   if (!formData.type) errors.type = "Type is required";
  //   if (!formData.unit || formData.unit <= 0)
  //     errors.unit = "Units must be a positive number";
  //   if (!formData.doc_type) errors.doc_type = "Document Type is required";
  //   if (!formData.doc_type_name_id)
  //     errors.doc_type_name_id = "Document Name is required";
  //   if (!formData.community_documents)
  //     errors.community_documents = "Document file is required";
  //   setErrors(errors);
  //   return Object.keys(errors).length === 0;
  // };

  const handleSubmit = (e) => {
    e.preventDefault();

    const selectedState = states.find((state) => state.isoCode === formData.state);
    const selectedStateName = selectedState ? selectedState.name : "";

    const formDataToSubmit = new FormData();
    formDataToSubmit.append("community_name", formData.community_name);
    formDataToSubmit.append("community_city", formData.city);
    formDataToSubmit.append("community_state", formData.state); // Send state name
    formDataToSubmit.append("type", formData.type);
    formDataToSubmit.append("unit", formData.unit);
    formDataToSubmit.append("owned_by", formData.owned_by);

    dispatch(
      updateCommunityApi({
        communityId: idFromState,
        formData: formDataToSubmit,
      })
    )
      .unwrap()
      .then((res) => {
        toast.success("Community Updated successfully!");
        if (user_type === CommunityOwner) {
          setTimeout(() => {
            navigate("/admin/Admin-community");
          }, 1000);
        }
        if (user_type === SuperAdmin) {
          setTimeout(() => {
            navigate("/super-admin/super-admin-community-comp");
          }, 1000);
        }
      })
      .catch((err) => {
        toast.error("Community Update failed!");
      });
  };


  useEffect(() => {
    const usaStates = State.getStatesOfCountry("US");
    setStates(usaStates);
  }, []);

  return (
    <>
      <div className="back-btn">
        <button onClick={() => navigate(-1)} className="back-btn-button">
          {/* <img src={chevronleft} alt="chevron-left" className="left-icon" />
           */}
          <ArrowBackIcon className="left-icon" />
          Back
        </button>
      </div>
      <div className="community-section">
        <div className="community-inner-wrap">
          <div className="add-new-community d-flex justify-content-between align-items-center">
            <div className="community-heading create-new">Update Community</div>
          </div>
          <div className="create-community-name-table">
            <div className="create-comm-inner-wrap">
              <form className="create-community-form">
                {/* Community Name */}
                <div className="main-community-block">
                  <div className="d-flex align-items-center community-city-blk">
                    <div className="comm-name-blk">
                      <InputLabel htmlFor="community-name">
                        Community Name
                      </InputLabel>
                      <Input
                        id="community_name"
                        className="input-box"
                        placeholder="Enter community name"
                        type="text"
                        name="community_name"
                        value={formData.community_name}
                        onChange={handleInputChange}
                        disabled
                      />
                      {errors.community_name && (
                        <div className="error-text">
                          {errors.community_name}
                        </div>
                      )}
                    </div>

                    {/* State */}
                    {/* State */}
                    <div className="city-name-blk">
                      <InputLabel htmlFor="state">State</InputLabel>
                      <select
                        id="state"
                        name="state"
                        className="dropdown-box"
                        value={formData.state}
                        onChange={handleStateChange}
                        disabled
                      >
                        <option value="" disabled selected>
                          Select state
                        </option>
                        {states.map((state) => (
                          <option key={state.id} value={state.isoCode}>
                            {" "}
                            {state.name}
                          </option>
                        ))}
                      </select>
                      {errors.state && (
                        <div className="error-text">{errors.state}</div>
                      )}
                    </div>
                  </div>

                  <div className="state-type-unit-blk d-flex align-items-center">
                    {/* City */}
                    <div className="mb-4">
                      <InputLabel htmlFor="city">
                        City <span>*</span>
                      </InputLabel>
                      <select
                        id="city"
                        name="city"
                        className="dropdown-box"
                        value={formData.city}
                        onChange={handleCityChange}
                        disabled
                      >
                        <option value="" disabled selected>
                          Select city
                        </option>
                        {cities.map((city) => (
                          <option key={city.id} value={city.isoCode}>
                            {" "}
                            {city.name}
                          </option>
                        ))}
                      </select>
                      {errors.city && (
                        <div className="error-text">{errors.city}</div>
                      )}
                    </div>

                    {/* Type */}
                    <div className="mb-4">
                      <InputLabel htmlFor="type">Type</InputLabel>
                      <select
                        id="type"
                        name="type"
                        className="dropdown-box"
                        value={formData.type}
                        onChange={handleTypeChange}
                      >
                        <option value="" disabled selected>
                          Select type
                        </option>
                        <option value="HOA">HOA</option>
                        <option value="COA">COA</option>
                        <option value="Co-op">Co-op</option>
                        <option value="Mobile Park">Mobile Park</option>
                        <option value="Timeshare">Timeshare</option>
                      </select>
                      {errors.type && (
                        <div className="error-text">{errors.type}</div>
                      )}
                    </div>

                    {/* Units */}
                    <div className="mb-4">
                      <InputLabel htmlFor="unit">Units</InputLabel>
                      <Input
                        id="unit"
                        className="input-box"
                        placeholder="Enter units"
                        type="number"
                        name="unit"
                        value={formData.unit}
                        onChange={handleInputChange}
                      />
                      {errors.unit && (
                        <div className="error-text">{errors.unit}</div>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <p className="doc-type-info mt-2">
              <b>Note:</b> To update the community name and address, please reach out to the admin.
            </p>
            <div className="create-comm-btn">
              <button
                type="submit"
                class="orange-filled-btn"
                onClick={handleSubmit}
              >
                Update Community
              </button>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default UpdatecommunityComp;
